module.exports = __webpack_public_path__ + "img/sign-6.6de60057.jpg";